<template>
  <div>
    <div class="app-content content devcontent">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
          <div class="container-fluid">
            <div class="row breadcrumbs-top">
              <div class="col-md-12 content-header-left px-0">
                <h3 class="content-header-title float-left mb-0">
                  Support
                </h3>
                <div class="breadcrumb-wrapper">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/support/tickets"
                        >Tickets</router-link
                      ></li>
                    <li class="breadcrumb-item">Ticket Roaster</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="content-body">
          <vue-element-loading :active="isLoading" :is-full-screen="true" />
          <section>
            <div class="card">
              <div
                class="card-header bg-white border-bottom_eee pt-1 px-1 mb-0 common_top_title_searchbgst_dock"
              >
                <div class="w-auto px-0 mobile-padding-0-2">
                  <div
                    class="avatar bg-light-secondary rounded d-inline-flex mr-1"
                  >
                    <div class="avatar-content">
                      <em class="las la-ticket-alt i_icon_st font-medium-5"></em>
                    </div>
                  </div>

                  <h4 class="card-title d-inline-flex ml-0 mb-0">
                    Add Ticket Roaster
                  </h4>
                </div>
              </div>
              <div class="col-lg-12 mt-2">
                <div class="card text-center mb-1">
                  <div
                    class="card-card-header text-editar_discription_jobs masters_detailstabing_pills px-0"
                  >
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                        <label class="form-label text-left w-100" for="department"> Department <span class="requiredField">*</span></label>
                        <treeselect placeholder="--- SELECT ---" id="department" v-model="formData.department_id" :options="department_list" @input="handleDepartmentSelection"/>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                        <label class="form-label text-left w-100" for="query-type"> Query/Category Type <span class="requiredField">*</span></label>
                        <treeselect placeholder="--- SELECT ---" id="query-type" v-model="formData.query_id" :options="query_list" />
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                        <label class="form-label text-left w-100" for="assignee"> Assignee <span class="requiredField">*</span></label>
                        <treeselect placeholder="--- SELECT ---" id="assignee" v-model="formData.assignee" multiple :options="assignee_list" />
                      </div>
                      
                      <div class="col-12 col-sm-6 col-md-6 col-lg-12 text-right mb-1 home_das_all_buttons_style mobileview_b_8 mt-2">
                          <button type="submit" class="btn btn-outline-primary waves-effect  mr-0" :disabled="!validateForm()" @click="saveData">
                              Submit
                          </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Quagga from "quagga";
import "vue2-datepicker/index.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import VueElementLoading from "vue-element-loading";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import searchMasterNameList from "../../../utils/searchMasterNameList";
import common_methods from "../../../utils/common_methods";
import axios from "axios"

export default {
  name: "TicketRoadster",
  mixins: [searchMasterNameList, common_methods],
  data() {
    return {
      isLoading: false,
      department_list: [],
      query_list: [],
      assignee_list: [],
      formData: {
        department_id: null,
        query_id: null,
        assignee: null,
      }
    };
  },
  components: {
    DatePicker,
    Treeselect,
    Loading,
    VueElementLoading,
    VueTimepicker,
  },
  mounted() {
    if (!localStorage.getItem("reloaded")) {
      localStorage.setItem("reloaded", "1");
      location.reload();
    }
    if (feather) {
      feather.replace({
        width: 14,
        height: 14,
      });
    }
    $(window).on("load", function () {
      if (feather) {
        feather.replace({
          width: 14,
          height: 14,
        });
      }
    });
  },
  created() {
    this.getDropDownData()
  },
  methods: {
    handleDepartmentSelection(id) {
      this.query_list = []
      this.formData.query_id = null
      this.assignee_list = []
      this.formData.assignee = null
      if(!id) {
        return
      }
      this.getAssignees(id)
      this.makeRequest('GET', `/tickets/query-types?department_id=${id}`)
        .then(result => {
          this.query_list = result.data
        })
        .catch(e => {
          this.displayError(e)
        })
    },
    getDropDownData() {
      this.getDepartmentList()
    },
    getDepartmentList() {
      this.searchNameMasterList('departments', 'department_name', null, 'department_id')
        .then(result => {
          this.department_list = result.data
        })
        .catch(e => {
          this.displayError(e)
        })
    },
    getAssignees(id) {
      this.makeRequest('GET', `/search/get-assignees?department_id=${id}`)
        .then(result => {
          this.assignee_list = result.data
        })
        .catch(e => {
          this.displayError(e)
        })
    },
    resetForm() {
      let formData = this.formData
      formData.department_id = null
      formData.query_id = null
      formData.assignee = null
    },
    validateForm() {
      let formData = this.formData
      if(!formData.department_id || !formData.query_id ) {
        return false
      }
      if(!formData.assignee || (formData.assignee && !formData.assignee.length)) {
        return false
      }
      return true
    },
    saveData() {
      console.log(this.formData)
      let url = "/support/tickets/add-ticket-roaster"
      this.isLoading = true
      this.makeRequest("POST", url, this.formData)
        .then(result => {
          this.isLoading = false
          if(result && result.data && result.data.status) {
            this.resetForm()
            this.sweetAlertSnackbar(result.data.message, 'success')
          } else {
            this.sweetAlertSnackbar(result.data.message, 'error')
          }
        })
        .catch(e => {
          this.displayError(e)
        })
    }
  },
};
</script>
<style scoped>
.alignment {
  margin-left: 20px;
  margin-bottom: 20px;
}
.requiredField {
  margin-left: 2px;
  color: red;
}

</style>
